import PropTypes from 'prop-types';
import React, { Component } from 'react';
import * as d3 from 'd3';
import styles from './ImpactTable.css';
import withStyles from '../../decorators/withStyles';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { gaEvent, simplePlaceName, isUS, xlt } from '../../utils/utils';
import AnchoredComponent from '../AnchoredComponent';
import ToggleText from '../ToggleText';
import ImpactGroup from '../ImpactGroup';
import SourcesCaption from '../SourcesCaption';
import { SetImpact, SetImpactName, SetImpactSubgroup } from '../../actions';


class ImpactTable extends AnchoredComponent {

  static propTypes = {
    impactMeta: PropTypes.object.isRequired,
    boundaryMeta: PropTypes.object.isRequired,
    elevMeta: PropTypes.object.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      refs: []
    }
  }

  componentDidUpdate() {
    this.state.refs.forEach(ref => {
      // Transifex.live.translateNode(ref);
    })
  }

  setTxContent = el => {
    // this.state.refs.push(el);
    d3.select(el).attr("tx-content", "block");
    // d3.select(el).attr("tx-dynamic", "disabled");
  };

  handleImpactClick = impact => {
    gaEvent('configure', 'impact', impact.key);
    this.props.dispatch(SetImpact(impact.key));
    this.props.dispatch(SetImpactName(impact.name));
  };

  handleSubgroupSelection = value => {
    gaEvent('configure', 'impact-subgroup', value);
    this.props.dispatch(SetImpactSubgroup(value));
  };

  render() {
    const { impacts, protection, noData, isEmbed, impactPct, waterLevel, impactGroup,
            placeName, impactName, impactSubgroup } = this.props;
    const totalToggle = (
      <ToggleText>
        <span onClick={this.props.handleImpactPctChange}>{impactPct ? "Percentage of" : "Total"}</span>
      </ToggleText>
    );

    const tableVarName = Object.keys(impacts).length > 1 ? impactGroup.toLowerCase() : "impacts";
    return (
      <div className={"ImpactTable " + (isEmbed ? "embedded" : "")}>
        <h2 ref={this.setTxContent} key={Math.random()}>{totalToggle} <span>{tableVarName}</span> below <var>{waterLevel.level}</var><var> {waterLevel.unit}</var> in <var>{xlt(simplePlaceName(placeName))}</var>
          {isUS(this.props.placeID) ?
              <svg className="download-icon" version="1.1" viewBox="0 0 585.918 585.918" onClick={this.props.handleDownloadClick.bind(null, "impact-summary")}>
                <g>
                  <path d="M11.176,46.207v492.31l346.22,47.401v-50.583c0.776,0.053,1.542,0.115,2.329,0.115h177.39
                        c20.745,0,37.627-16.888,37.627-37.628V86.602c0-20.743-16.882-37.628-37.627-37.628h-177.39c-0.787,0-1.553,0.076-2.329,0.123V0
                          L11.176,46.207z M357.396,355.122H435.9v34.939h-78.504V355.122z M357.396,309.432v-34.942H435.9v34.942H357.396z M100.615,350.802
                          l-9.659-21.345c-3.913-8.151-6.406-14.161-9.352-20.855l-0.317-0.006c-2.161,6.578-4.78,12.437-7.988,20.279l-8.504,20.168
                          l-25.69-1.254l28.866-55.881l-27.856-54.79l25.882-1.063l8.979,20.411c3.068,6.858,5.386,12.427,7.863,18.839h0.305
                          c2.496-7.347,4.522-12.501,7.184-19.22l9.014-21.399l28.302-1.173l-30.845,57.819l32.517,60.872L100.615,350.802z M218.837,356.587
                          l-75.733-3.7V232.875l26.564-1.098v99.156l49.164,1.565v24.089H218.837z M269.032,360.991c-15.527-0.787-30.541-5.35-37.927-9.691
                          l6.013-23.747c8.047,4.241,20.588,8.692,33.753,9.134c14.455,0.483,22.205-4.998,22.205-13.717c0-8.325-6.708-13.182-23.431-19.082
                          c-22.501-7.736-36.812-19.602-36.812-38.231c0-21.85,18.869-39.386,51.245-40.772c15.981-0.682,27.992,2.016,36.687,5.294
                          l-7.398,24.985c-5.825-2.473-16.067-6.008-29.918-5.654c-13.594,0.354-20.098,6.355-20.098,13.142
                          c0,8.349,7.73,11.972,25.735,18.325c25.368,8.73,37.609,21.306,37.609,40.55C326.697,344.44,307.769,362.944,269.032,360.991z
                           M359.726,70.476h177.39c8.893,0,16.125,7.236,16.125,16.126v411.22c0,8.893-7.232,16.127-16.125,16.127h-177.39
                          c-0.797,0-1.563-0.116-2.329-0.232V395.438h173.024v-166.64H357.396V70.72C358.162,70.604,358.929,70.476,359.726,70.476z
                           M525.046,274.489v34.942h-83.765v-34.942H525.046L525.046,274.489z M441.281,269.113v-34.94h83.765v34.94H441.281z
                           M525.046,355.122v34.939h-83.765v-34.939H525.046z"/>
                </g>
              </svg>
              : null}
        </h2>
        {Object.keys(impacts)
          .filter(k => this.props.impactGroup === k)
          .map(k =>
            <ImpactGroup
              placeName={this.props.placeName}
              placeID={this.props.placeID}
              handleClick={this.handleImpactClick}
              selected={this.props.impact}
              impactPct={this.props.impactPct}
              className="ImpactGroup"
              key={k}
              name={k}
              factCriteria={this.props.factCriteria}
              waterLevel={this.props.waterLevel}
              protection={protection}
              impacts={impacts[k]}
              numGroups={Object.keys(impacts).length}
              subcategoryExclusions={this.props.subcategoryExclusions}
              noData={noData}
              isEmbed={isEmbed}
              // srcCaption={this.props.srcCaption}
              impactName={impactName}
              handleSubgroupSelection={this.handleSubgroupSelection}
              impactSubgroup={impactSubgroup}
              toggleProtection={this.props.toggleProtection}
            >
              <SourcesCaption
                  impactMeta={this.props.impactMeta}
                  boundaryMeta={this.props.boundaryMeta}
                  elevMeta={this.props.elevMeta}
                  impactName={impactName}
                  openSources={this.props.openSources}
              />
            </ImpactGroup>
          )
        }
      </div>
    )
  }
}

export default compose(
  withStyles(styles),
  connect((state) => { return {impactSubgroup: state.impactSubgroup};}),
)(ImpactTable);
